module.exports = __webpack_public_path__ + "static/img/4.166aa36.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/eng/4.png
// module id = WqzA
// module chunks = 0